import React, { Fragment } from "react";
import { Link } from "gatsby";
import Cta from "components/common/Cta";
import "./styles.sass";
import T from "types/index";
import { AirtableImages } from "components/common/utils/AirtableImage";
import { AirtableMarkdown } from "components/common/utils/AirtableMarkdown";
import Image from "components/common/utils/Image";

type Props = {
  how_title: T.Standard.Markdown
  how_items: T.Charles.ItemRecord[]
  start_slug: string
  cta: any
}

const HowItWorksSection = (props: Props) => {

  return (
    <div className="landing-how-it-works how-it-works-pathology-style">
      <div
        id="how-it-works-anchor"
        className="pathology-how-it-works-anchor pathology-anchor"
      />
      <div className="landing-how-it-works-h2">
        <h2><AirtableMarkdown markdown={props.how_title} /></h2>
        <Image
          filename="new-images/black-pen-underline.svg"
          className="black-underline"
          alt="black-pen-underline"
          title="black pen underline"
        />
      </div>
      <div className="how-it-works-cards-wrapper">
        {props.how_items.map((item: T.Charles.ItemRecord, i: number) => (
          <Fragment key={`how-it-works-card-${i}`}>
            <div className="how-it-works-card">
              <div className="how-it-works-card-box">
                <AirtableImages
                  images={item.data.image}
                  className="card-box-image"
                />
              </div>
              <div className="how-it-works-text">
                <h3><AirtableMarkdown markdown={item.data.title} raw/></h3>
                <AirtableMarkdown markdown={item.data.text} />
              </div>
            </div>
            {i < props.how_items.length - 1 && (
              <Image
                filename="new-images/white-tag.svg"
                className="how-it-works-tag-between-card d-none d-xl-block"
                alt="white-tag"
                title="white tag"
              />
            )}
          </Fragment>
        ))}
      </div>
      <div className="how-it-works-security-card-placeholder how-it-works-security-card-pathology">
        <div className="how-it-works-security-card">
          <Image
            filename="new-images/icon-med.svg"
            alt="donnees-protegees-icon"
            title="donnees protegees icon"
          />
          <div className="security-card-text-wrapper">
            <div className="security-text-content">
              Vos données sont sécurisées et soumises au secret médical
            </div>
            <Link
              to="/politique-de-confidentialite/"
              className="security-text-find-out-more"
            >
              <div>En savoir plus</div>
              <Image
                filename="new-images/arrow-link.svg"
                alt="fleche-droite-fine-picto"
                title="fleche droite fine picto"
              />
            </Link>
          </div>
        </div>
      </div>
      {props.cta || (
        <Cta
          text="Consultez un spécialiste"
          path={props.start_slug}
          className="new-primary-cta how-it-works-cta-pathology"
        />
      )}
    </div>
  );
};

export default HowItWorksSection;
